import { useEffect, useState } from "react";
import stl from "./Sort.module.css";
import { CDN_LINK } from "@globalConfig";
import { isRangeFilter } from "@/pages/search/searchHooks/utils";
import { useTranslation } from "@i18n";
import ProgressiveImage from "@componentsShared/ProgressiveImage";
import useIsMobile from "@hooks/useIsMobile";
import useHelpers from "@hooks/useHelpers";
import {useLocation} from "react-router-dom";

const UnbxdSort = ({
  className,
  sort,
  selectedOptions,
}) => {
  const location = useLocation();
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const {navigateTo} = useHelpers()
  const [options, setOptions] = useState([
    {
      id: 2,
      text: t("أكبر خصم", { ns: "web_search" }),
      sort: "-discount",
    },
    {
      id: 3,
      text: t("الأقل سعراً", { ns: "web_search" }),
      sort: "sellingprice",
    },
    {
      id: 4,
      text: t("الأعلى سعراً", { ns: "web_search" }),
      sort: "-sellingprice",
    },
    {
      id: 5,
      text: t("الأقل ممشى", { ns: "web_search" }),
      sort: "odometer",
    },
    {
      id: 6,
      text: t("الأعلى ممشى", { ns: "web_search" }),
      sort: "-odometer",
    },
    {
      id: 7,
      text: t("السيارات الأحدث", { ns: "web_search" }),
      sort: "-first_active_date",
    },
  ]);
  const [showOptions, setShowOptions] = useState(false);
  const [selectedOption, setSelectedOption] = useState({});


  const handleSortChange = (option) => {
    const newSort = selectedOption.id === option.id ? "" : option;

    setSelectedOption(newSort);

    const searchParams = new URLSearchParams(location.search);
    if(location?.pathname?.includes('deal')){
      location.pathname?.split('/deal/')[1] && searchParams.set("deal_id", location.pathname.split('/deal/')[1]);
    }

    if (newSort.sort) {
      searchParams.set("sort", option?.sort);

      const mappedOptions = groupUnbxdFilters(selectedOptions);

      if (Object.values(mappedOptions).length) {
        Object.entries(mappedOptions).forEach(([key, value]) => {
          searchParams.set(key, Array.isArray(value) ? value.join(",") : value);
        });
      }
    } else {
      searchParams.delete("sort");
    }
    searchParams.delete("page");

    const newUrl = `?${searchParams.toString()}`;

    navigateTo(`/filters${newUrl}`);
  };

  useEffect(() => {
    const isNew = selectedOptions?.some(
      (option) => option.id == 1 && option?.filterField === "condition_id"
    );
    const isUsed = selectedOptions?.some(
        (option) => option.id == 0 && option?.filterField === "condition_id"
    );

    if (isNew && !isUsed) {
      // setSelectedOption({});
      setOptions((pre) =>
        pre.filter((option) => option.id !== 5 && option.id !== 6)
      );
    } else {
      setOptions([
        {
          id: 2,
          text: t("أكبر خصم", { ns: "web_search" }),
          sort: "-discount",
        },
        {
          id: 3,
          text: t("الأقل سعراً", { ns: "web_search" }),
          sort: "sellingprice",
        },
        {
          id: 4,
          text: t("الأعلى سعراً", { ns: "web_search" }),
          sort: "-sellingprice",
        },
        {
          id: 5,
          text: t("الأقل ممشى", { ns: "web_search" }),
          sort: "odometer",
        },
        {
          id: 6,
          text: t("الأعلى ممشى", { ns: "web_search" }),
          sort: "-odometer",
        },
        {
          id: 7,
          text: t("السيارات الأحدث", { ns: "web_search" }),
          sort: "-first_active_date",
        },
      ]);
    }
  }, [selectedOptions]);

  useEffect(() => {
    // if (!sort) return;
    if (!sort) return setSelectedOption({});

    const preSelectedOption = options.find((option) => option.sort === sort);
    if (preSelectedOption) setSelectedOption(preSelectedOption);

    return () => {
      setSelectedOption(options[0]);
    };
  }, [sort]);

  return (
    <>
      <div
        className={[
          stl.sortFilterSp,
          className ? className : undefined,
          stl.wrapper,
          isMobile ? stl.isMobile : undefined,
        ].join(" ")}
        onClick={() => setShowOptions((pre) => !pre)}
      >
        <ProgressiveImage
          waitUntilInteractive
          className="m-show"
          src={CDN_LINK + "/assets/images/sort-icon-mobile.svg"}
          alt="sort"
          aria-label="sort"
          width={14}
          height={12}
        />
        {!Object.keys(selectedOption).length && (
          <strong>{t("رتب", { ns: "web_search" })}</strong>
        )}
        <strong>{selectedOption.text}</strong>

        {showOptions && (
          <ul>
            <div className={stl.clsSortSel} onClick={() => {}}>
              <span/>
              <img src={CDN_LINK + "/assets/images/clsSortMenu.svg"} alt="" />
              <strong className="m-show">
                {t("رتب", { ns: "web_search" })}
              </strong>
            </div>
            {options.map((option, i) => {
              return (
                <li
                  key={i}
                  onClick={() => handleSortChange(option)}
                  className={[
                    stl.radioshapedDl,
                    selectedOption.id === option.id ? stl.active : "",
                  ].join(" ")}
                >
                  <input id={option.text} type="radio" />

                  <label htmlFor={option.text}>
                    {t(option.text, { ns: "web_search" })}
                  </label>

                  {selectedOption.id === option.id ? (
                    <ProgressiveImage
                      waitUntilInteractive
                      src={CDN_LINK + "/assets/images/check-mark.svg"}
                      width={24}
                      height={24}
                      alt={"check-mark"}
                    />
                  ) : (
                    <span className={stl.emptyCir}/>
                  )}
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </>
  );
};

export default UnbxdSort;

function groupUnbxdFilters(filters) {
  if (!filters) return;

  const noneRangeFilters = filters.filter(
    (filter) => !isRangeFilter(filter?.filterField)
  );

  const rangeFilters = filters.filter((filter) =>
    isRangeFilter(filter?.filterField)
  );

  const groupedRangeFilters = {};
  rangeFilters.forEach((filter) => {
    groupedRangeFilters[`${filter?.filterField}_from`] =
      filter.range_values.from;
    groupedRangeFilters[`${filter?.filterField}_to`] = filter.range_values.to;
  });

  const groupedNoneRangeFilters = noneRangeFilters.reduce((acc, obj) => {
    if (!acc[obj?.filterField]) {
      acc[obj?.filterField] = [];
    }
    acc[obj?.filterField].push(obj.id);
    return acc;
  }, {});

  return { ...groupedNoneRangeFilters, ...groupedRangeFilters };
}
